import { render, staticRenderFns } from "./PlantTarifa.vue?vue&type=template&id=22f8b3b8"
import script from "./PlantTarifa.vue?vue&type=script&lang=js"
export * from "./PlantTarifa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports